<template>
    <v-container fluid class="" style="margin-top: 60px">
        <!-- MENU DE LOS SENIOR -->
        <v-tabs color="primary" right v-model="tab" show-arrows v-if="canOnlySee == false && isSeniorBlog == true">
            <v-tab>Inicio</v-tab>
            <v-tab>Categorías</v-tab>
            <v-tab> {{ publishEditing == false ? 'Publicar Artículo' : 'Editar Artículo' }} </v-tab>
            <v-tab>Mis Borradores</v-tab>
            <v-tab>En Revisión </v-tab>
            <v-tab :class="tab == 5 ? 'view-tab' : 'no-view-tab'">Revisión</v-tab>

            <!-- INICIO TAB -->
            <v-tab-item>
                <v-container fluid v-if="tab == 0">
                    <blogMain :canOnlySee="canOnlySee" @toggle-detail="receiveDrafsEmit"></blogMain>
                </v-container>
            </v-tab-item>

            <v-tab-item>
                <v-container fluid v-if="tab == 1">
                    <blogCategorias></blogCategorias>
                </v-container>
            </v-tab-item>

            <v-tab-item>
                <v-container fluid v-if="publishEditing == false && tab == 2">
                    <blogPublish @cancel-edit="resetMainScreen"></blogPublish>
                </v-container>
                <v-container fluid v-if="publishEditing == true">
                    <blogPublishEdit @cancel-edit="cancelPublishEdit" :currentBlogData="currentBlogData"></blogPublishEdit>
                </v-container>
            </v-tab-item>

            <v-tab-item>
                <v-container fluid v-if="tab == 3">
                    <blogDrafts @toggle-detail="receiveDrafsEmit"></blogDrafts>
                </v-container>
            </v-tab-item>

            <v-tab-item>
                <v-container fluid v-if="tab == 4">
                    <blogReview @toggle-detail="receiveDrafsEmit"></blogReview>
                </v-container>
            </v-tab-item>

            <v-tab-item>
                <v-container fluid v-if="tab == 5">
                    <blogDetail :currentBlogData="currentBlogData" :isJunior="false" @reset-main="resetMainScreen"
                        @edit-art="editArticulo">
                    </blogDetail>
                </v-container>
            </v-tab-item>
        </v-tabs>


        <!-- MENU DE LOS JUNIOR -->
        <v-tabs color="primary" right v-model="tab" show-arrows v-if="canOnlySee == false && isSeniorBlog == false">
            <v-tab>Inicio</v-tab>
            <v-tab> {{ publishEditing == false ? 'Publicar Artículo' : 'Editar Artículo' }} </v-tab>
            <v-tab>Mis Borradores</v-tab>
            <v-tab :class="tab == 3 ? 'view-tab' : 'no-view-tab'">Revisión</v-tab>

            <!-- INICIO TAB -->
            <v-tab-item>
                <v-container fluid v-if="tab == 0">
                    <blogMain :canOnlySee="canOnlySee" @toggle-detail="receiveDrafsEmitJunior"></blogMain>
                </v-container>
            </v-tab-item>

            <v-tab-item>
                <v-container fluid v-if="publishEditing == false && tab == 1">
                    <blogPublish @cancel-edit="resetMainScreen"></blogPublish>
                </v-container>
                <v-container fluid v-if="publishEditing == true">
                    <blogPublishEdit @cancel-edit="cancelPublishEdit" :currentBlogData="currentBlogData"></blogPublishEdit>
                </v-container>
            </v-tab-item>

            <v-tab-item>
                <v-container fluid v-if="tab == 2">
                    <blogDrafts @toggle-detail="receiveDrafsEmitJuniorCanEdit"></blogDrafts>
                </v-container>
            </v-tab-item>

            <v-tab-item>
                <v-container fluid v-if="tab == 3">
                    <blogDetail :currentBlogData="currentBlogData" :isJunior="isJunior" @reset-main="resetMainScreen"
                        @edit-art="editArticuloJunior">
                    </blogDetail>
                </v-container>
            </v-tab-item>
        </v-tabs>

        <!-- MENU DE GENTE SIN PERMISOS -->
        <div v-if="canOnlySee == true">
            <blogMainNoActions></blogMainNoActions>
        </div>
    </v-container>
</template>

<script>
import { mapState } from "vuex";
import blogMain from "@/components/pages/BlogAdmin/BlogMain";
import blogCategorias from "@/components/pages/BlogAdmin/BlogCategorias";
import blogPublish from "@/components/pages/BlogAdmin/BlogPublish";
import blogPublishEdit from "@/components/pages/BlogAdmin/BlogPublishEdit";
import blogReview from "@/components/pages/BlogAdmin/BlogReview";
import blogDrafts from "@/components/pages/BlogAdmin/BlogDrafts";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

import blogMainNoActions from "@/components/pages/main/blog/blogMain";

import blogDetail from "@/components/pages/BlogAdmin/BlogAdminDetail";

    export default {
        title() {
            return this.$route.meta.title
        },
    components: {
        blogMain,
        blogCategorias,
        blogPublish,
        blogReview,
        blogDrafts,
        blogDetail,
        blogPublishEdit,
        blogMainNoActions
    },
    data() {
        return {
            tab: null,
            currentBlogData: null,
            publishEditing: false,
            isSeniorBlog: false,

            isJunior: true,
            canAccess: false,
            canOnlySee: true,
        };
    },
    computed: {
        ...mapState(["domain", "informationPage"]),
    },
    mounted() {
        this.verficarPermiso();
        this.obtenerPermisoSenior();


    },
    methods: {
        receiveDrafsEmit(data) {
            this.currentBlogData = null;
            this.currentBlogData = data
            this.tab = 5
        },

        receiveDrafsEmitJunior(data) {
            this.currentBlogData = null;
            this.currentBlogData = data
            this.isJunior = true;
            this.tab = 3
        },

        receiveDrafsEmitJuniorCanEdit(data) {
            this.currentBlogData = null;
            this.currentBlogData = data
            this.isJunior = false;
            this.tab = 3
        },

        resetMainScreen() {

            this.currentBlogData = null
            this.tab = 0
        },

        editArticulo(data) {
            this.currentBlogData = null;
            this.currentBlogData = data
            this.publishEditing = true;
            this.tab = 2
        },

        editArticuloJunior(data) {
            this.currentBlogData = null;
            this.currentBlogData = data
            this.publishEditing = true;
            this.tab = 1
        },

        cancelPublishEdit() {
            this.currentBlogData = null
            this.publishEditing = false;
            this.tab = 0
        },

        async obtenerPermisoSenior() {
            let response = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '55');
            if (response.data.length > 0) {
                this.isSeniorBlog = true;
            }
        },

        async verficarPermiso() {
            let response = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '70,71');
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 70) {
                        this.canAccess = true;
                        this.canOnlySee = true;
                    }
                    if (permiso.peclave == 55) { //Permiso senior
                        this.canAccess = true;
                        this.canOnlySee = false;
                    }
                    if (permiso.peclave == 71) {//Permiso junior
                        this.canAccess = true;
                        this.canOnlySee = false;
                    }

                });
            }

            let responseSenior = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '55');
            if (responseSenior.data.length > 0) {
                responseSenior.data.forEach(permiso => {
                    if (permiso.peclave == 55) { //Permiso senior
                        this.canAccess = true;
                        this.canOnlySee = false;
                    }
                });
            }

            if (this.canAccess == false) {
                this.$router.push({ name: `noautorizado` }).catch(error => error);
            }
        },

    },
    watch: {},
};
</script>

<style scoped>
.no-view-tab {
    pointer-events: none !important;
    display: none;
}

.view-tab {
    pointer-events: none !important;
}
</style>